var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSubStepIconOnHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9959 25.3334C15.68 25.3334 15.4165 25.2269 15.2054 25.014C14.9943 24.801 14.8887 24.5371 14.8887 24.2223V17.1112H7.7776C7.4628 17.1112 7.19891 17.0043 6.98594 16.7906C6.77298 16.5769 6.6665 16.3121 6.6665 15.9962C6.6665 15.6803 6.77298 15.4168 6.98594 15.2056C7.19891 14.9945 7.4628 14.889 7.7776 14.889H14.8887V7.77785C14.8887 7.46305 14.9956 7.19916 15.2093 6.98618C15.423 6.77323 15.6878 6.66675 16.0037 6.66675C16.3197 6.66675 16.5832 6.77323 16.7943 6.98618C17.0054 7.19916 17.1109 7.46305 17.1109 7.77785V14.889H24.2221C24.5369 14.889 24.8008 14.9958 25.0137 15.2095C25.2267 15.4233 25.3332 15.6881 25.3332 16.004C25.3332 16.3199 25.2267 16.5834 25.0137 16.7945C24.8008 17.0056 24.5369 17.1112 24.2221 17.1112H17.1109V24.2223C17.1109 24.5371 17.0041 24.801 16.7904 25.014C16.5767 25.2269 16.3118 25.3334 15.9959 25.3334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSubStepIconOnHover);
export default __webpack_public_path__ + "static/media/addSubStepIconOnHover.ecae7db3.svg";
export { ForwardRef as ReactComponent };